// removed by extract-text-webpack-plugin
module.exports = {"base":"Member_base--3SAaU","base__offline":"Member_base__offline--2aFoW","baseOffline":"Member_base__offline--2aFoW","base__online":"Member_base__online--7JL4t","baseOnline":"Member_base__online--7JL4t","base__busy":"Member_base__busy--VB116","baseBusy":"Member_base__busy--VB116","isFriend":"Member_isFriend--2J0E3","isOwn":"Member_isOwn--37HpM","clanTag":"Member_clanTag--jta64"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/Member/Member.css
// module id = 1818
// module chunks = 16